import { ReactNode, useContext, useMemo, useState } from "react";
import { CachedDocument, getProcesses } from "../adapters/Firebase";
import { Process } from "../data/Process";
import { ProcessesContext } from "./Processes.context";
import { UserContext } from "./User.context";

interface ProcessesProviderProps {
	children: ReactNode;
}

function docToProcess(doc: any, id: string): Process {

	const modifiers = doc.modifiers ? Object.keys(doc.modifiers).map(key => {
		return {
			id: key,
			title: doc.modifiers[key].title,
			description: doc.modifiers[key].description,
			format: doc.modifiers[key].format,
			payload: doc.modifiers[key].payload,
			default: doc.modifiers[key].default,
			order: doc.modifiers[key].order,
			isFixed: doc.modifiers[key].fixed
		};
	}) : [];

	const quickActions = doc.quickActions ? Object.keys(doc.quickActions).map(key => {
		return {
			tag: doc.quickActions[key].tag,
			title: doc.quickActions[key].title,
			icon: doc.quickActions[key].icon,
		};
	}) : [];

	return {
		id: id,
		name: doc.name,
		tag: doc.tag,
		type: doc.type,
		isPublic: !!doc.isPublic,
		modifiers: modifiers,
		minVersion: doc.minVersion,
		quickActions: quickActions,
		adminOnly: !!doc.adminOnly
	}
}

function ProcessesProvider(props: ProcessesProviderProps) {

	const user = useContext(UserContext);
	const [processes, setProcesses] = useState<Process[]>([]);
	
	useMemo(() => {
		if (!user) {
			setProcesses([]);
			return;
		}
		getProcesses().then((retrievedProcesses: any) => {
			let processArr: Process[] = retrievedProcesses.map((p: CachedDocument) => docToProcess(p.doc, p.id));
			if (!user.isAdmin) {
				processArr = processArr.filter(p => !p.adminOnly);
			}
			setProcesses(() => processArr);
		});
	}, [user]);

	return (
		<ProcessesContext.Provider value={{ processes, setProcesses }}>
			{props.children}
		</ProcessesContext.Provider>);
}

export default ProcessesProvider;